__turbopack_context__.v({
  "card": "GridWithBannerSection-module-scss-module__r8uvea__card",
});
